import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    ` 
    SET_CAR_PRICE_DETAIL
    FETCH_LEAD_DETAIL_FAILURE
    SET_IS_SUBMITTED
    SET_ACTIVE_SCREEN
    IS_SUBMITTING_DATA
    IS_PINCODE_GS_ELIGBLE
    POST_SELL_ONLINE_QUESTIONS
    SET_MMYVS_ELIGIBLITY
    STORE_ANSWERED_QUESTION
    SET_IS_GS_ELIGIBLE
    FETCH_APPOINTMENT_DETAIL_SUCCESS
    FETCH_APPOINTMENT_DETAIL_FAILURE
    FETCH_APPOINTMENT_DETAIL_INIT
    POST_OFFER_PRICE_INPUT_SUCCESS
    SET_OFFER_PRICE
    UPDATE_APPOINTMENT_BOOKING_FAILURE
    UPDATE_APPOINTMENT_BOOKING_INIT
    SET_CURRENT_QUESTION_INDEX
    FETCH_DATE_SLOTS_SUCCESS
    FETCH_DATE_SLOTS_FAILURE
    FETCH_DATE_SLOTS_INIT
    SET_DATA_FROM_SSR
    SET_SSR
    RESET_QUESTIONS
    SET_REGISTRATION_NUMBER
    SET_LEAD_CREATED_TYPE
    SET_DEALER_CODE
    GET_DEALER_CAR_PRICE
    SET_QUESTIONS_ARRAY
    VERIFY_OTP_SUCCESS
    SEND_OTP_SUCCESS
    FETCH_OFFER_SLOTS_BY_LOCATIONS_SUCCESS
    FETCH_OFFER_SLOTS_BY_LOCATIONS_FAILURE
    SET_IS_SELL_ONLINE_CITY
    SET_USER_REPORT
    SET_HYPOTHECATION
`,
    {
        prefix: "sellOnlinePrice/"
    }
);
